<template>
    <div class="monthForm">
        <div class="histogramView">
            <p>收益走势单位：元</p>
            <ve-line :data="chartData" :legend-visible="false" :settings="lineChartSettings" height="57.6vw"
                :extend="chartExtend" />
        </div>
        <!-- <div class="echartsView">
            <div class="pieView">
                <ve-pie
                    :data="pieData"
                    :settings="chartSettings"
                    :legend-visible="false"
                />
            </div>
            <div class="echartsRightView">
                <div>
                    <div class="pieTitle">收益</div>
                </div>
                <div class="pieAmount">{{ totalObj.fagentMoney }}</div>
                <div class="aountView">
                    <div class="pieLegend" />
                    <span class="pieLegendText">充电宝：</span>
                    <span class="pieLegendNumber">{{
                        totalObj.fagentMoneyByPowerBank
                    }}</span>
                    <div
                        class="pieLegend"
                        style="margin-left: 4.93vw;background-color: #ffc082;"
                    />
               </div>
            </div>
        </div> -->
        <div class="totalView">

            <div class="countNumber">{{ totalObj.fagentMoney }}</div>
            <div class="countTitle">收益</div>
        </div>
        <div class="countView">
            <div class="textCenter">

                <div class="countNumber">{{ totalObj.orderCount }}</div>
                <div class="countTitle">订单数量</div>
            </div>
            <div class="textCenter">

                <div class="countNumber">{{ totalObj.storeCount }}</div>
                <div class="countTitle">网点数量(个)</div>
            </div>
        </div>
        <storeItem v-for="(item, index) in storeList" :item="item" :key="index" :showOrderCount="true" />
        <Button class="loadingMoreBtn" size="mini" v-if="isLoadMore" @click="loadMore">展开查看更多</Button>
        <Divider v-else>暂无更多数据</Divider>
    </div>
</template>

<script>
/*
 * @AUTHOR: Mr.Huang
 * @DATA: 2020/6/3 4:42 下午
 * 月报表
 */
import storeItem from "../../components/storeItem";
import { Button, Divider } from "vant";
import {
    getReportByMonth as getReportByMonthApi,
    getStoreList as getStoreListApi
} from "../../api/reportForms";

export default {
    name: "monthForm",
    components: { storeItem, Button, Divider },
    props: {
        date: {
            type: String,
            default: ""
        }
    },
    watch: {
        date: {
            immediate: true,
            handler() {
                this.page = 1;
                this.storeList = [];
                this.getStoreList();
                this.getReportByMonth();
            }
        }
    },
    data() {
        return {
            chartExtend: {
                grid: {
                    top: "10%",
                    bottom: "4%",
                    containLabel: true
                },
                series: {
                    label: { show: true, position: "top" }
                }
            },
            lineChartSettings: {
                labelMap: {
                    moneyYuan: "日收益"
                }
            },
            chartSettings: {
                radius: 40,
                offsetY: 40,
                hoverAnimation: false,
                labelLine: {
                    show: false
                }
            },
            pieData: {
                columns: ["type", "number"],
                rows: []
            },
            chartData: {
                columns: ["dayName", "moneyYuan"],
                rows: []
            },
            storeList: [],
            page: 1,
            isLoadMore: true,
            totalObj: {
                fagentMoney: 0,
                fagentMoneyByCharger: 0,
                fagentMoneyByPowerBank: 0,
                orderCount: 0,
                storeCount: 0
            }
        };
    },
    methods: {
        loadMore() {
            this.page += 1;
            this.getStoreList();
        },
        getStoreList() {
            let { page, date } = this;
            getStoreListApi({ page, date }).then(result => {
                this.storeList = [...this.storeList, ...result.records];
                if (result.records.length < 10) {
                    this.isLoadMore = false;
                }
            });
        },
        getReportByMonth() {
            let { date } = this;
            getReportByMonthApi(date).then(result => {
                let {
                    dayIncomeByMonthList,
                    fagentMoneyByCharger,
                    fagentMoneyByPowerBank,
                    fagentMoney,
                    orderCount,
                    storeCount
                } = result;
                this.chartData.rows = dayIncomeByMonthList;
                this.totalObj = {
                    fagentMoneyByCharger,
                    fagentMoneyByPowerBank,
                    fagentMoney,
                    orderCount,
                    storeCount
                };
                this.pieData.rows = [
                    // { type: "线", number: fagentMoneyByCharger },
                    { type: "宝", number: fagentMoneyByPowerBank }
                ];
            });
        }
    }
};
</script>

<style lang="less" scoped>
.monthForm {
    .histogramView {
        margin: 3.2vw 0;
        padding-top: 3.87vw;
        background-color: #ffffff;
        border-radius: 2.67vw;
        box-shadow: 0 0.53vw 1.33vw -0.53vw rgba(0, 0, 0, 0.08);
        box-sizing: border-box;

        p {
            text-indent: 2em;
            font-size: 2.67vw;
            color: #c6c6c6;
        }
    }

    .echartsView {
        display: flex;
        width: 93.73vw;
        height: 31.2vw;
        margin: 0 auto;
        padding: 4.53vw 0 5.33vw 8.27vw;
        background-color: #ffffff;
        border-radius: 2.67vw;
        box-sizing: border-box;
        box-shadow: 0 0.53vw 1.33vw -0.53vw rgba(0, 0, 0, 0.08);

        .pieTitle {
            display: inline-block;
            font-size: 3vw;
            color: #282828;
            line-height: 4vw;
            border-bottom: 0.53vw solid #82c1ff;
        }

        .pieAmount {
            font-size: 5.33vw;
            color: #82c1ff;
        }

        .aountView {
            display: flex;
            align-items: center;
        }

        .pieLegend {
            width: 1.87vw;
            height: 1.87vw;
            margin-right: 1.6vw;
            background-color: #82c1ff;
            border-radius: 50%;
        }

        .pieLegendText,
        .pieLegendNumber {
            font-size: 3.2vw;
            color: #323232;
        }

        .echartsRightView {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
    }

    .totalView {
        width: 93.87vw;
        height: 21.07vw;
        margin-top: 3.2vw;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #ffffff;
        border-radius: 2.67vw;
        box-shadow: 0 0.53vw 1.33vw -0.53vw rgba(0, 0, 0, 0.08);
    }

    .countView {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 93.87vw;
        height: 21.07vw;
        margin-top: 3.2vw;
        background-color: #ffffff;
        border-radius: 2.67vw;
        box-shadow: 0 0.53vw 1.33vw -0.53vw rgba(0, 0, 0, 0.08);
    }

    .textCenter {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .countTitle {
        margin-top: 1.87vw;
        font-size: 3vw;
        color: #333333;
    }

    .countNumber {
        font-size: 5.33vw;
        color: #43a2fe;
    }

    .loadingMoreBtn {
        display: block;
        width: 100%;
        border: none;
        margin-top: 4.4vw;
        height: 6.93vw;
        font-size: 2.93vw;
        color: #fff;
        background-color: #43a2fe;
        border-radius: 1.33vw;
    }

    .pieView {
        width: 21.33vw;
        height: 21.33vw;
        margin-right: 5.33vw;
        overflow: hidden;
    }
}
</style>



// WEBPACK FOOTER //
// src/page/reportForms/monthForm.vue